import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LogService, NotificationService, UserService, WorkflowService } from '@app/services';
import { NgIf } from '@angular/common';

/**
 * TODO: Possible Remove
 * I ended up going a different route, but keeping this in case we need a workflow-step style approach
 */
@Component({
    selector: "choose-context",
    templateUrl: "./choose-context.component.html",
    styleUrls: ["./choose-context.component.less"],
    imports: [NgIf]
})
export class ChooseContextComponent implements OnInit {
  private readonly _componentName = 'ChooseContextComponent';

  private workflowName = 'ScheduleOnly Booking Workflow';
  private workflowStepName = 'cc';

  constructor(
    private workflowService: WorkflowService,
    private notify: NotificationService,
    private route: ActivatedRoute,
    private router: Router,
    private log: LogService,
    private userService: UserService
  ) {}

  ngOnInit() {}

  public get isAdmin(): boolean {
    return this.userService.isAdmin;
  }

  /**
   * Is verbose logging enabled
   */
  private get verboseLogging(): boolean {
    return this.log.verboseLogging;
  }

  public onSelfClick() {
    this.workflowService.stepIsReadyToBeMarkedCompleted(this.workflowName, this.workflowStepName);
  }

  public onOtherClick() {
    console.log(`${this._componentName}.onOtherClick()`);

    const route = '../schedule-other';

    this.router.navigate([route], { relativeTo: this.route });
  }
}
